import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { BuilderBlocks } from '@builder.io/react/lite';
import { CTAButtonsContainer, ButtonStyled } from './magic-svg.styles';
import MailIcon from './icons/mail.svg';
import ScrapIcon from './icons/scrap.svg';
import { MagicSvgContext } from '../../context/MagicSvgContext/MagicSvgContext';
import { STATUS } from '../../context/MagicSvgContext/magicSvgReducer';
import { USER_ACTIONS, IMAGE_STATUS } from './constants';

function MagicSvgActionButtons({
  currentView,
  isPerformingAction,
  handleRegenerate,
  handleStartNew,
  handleDelivery,
  handleScrap,
}) {
  const {
    image,
    generationStatus,
    builderPageId,
    regenerateButtonContent,
  } = useContext(MagicSvgContext);

  const isLoading = generationStatus === STATUS.LOADING || isPerformingAction;
  return (
    <CTAButtonsContainer
      container
      item>
      {currentView === USER_ACTIONS.REGENERATE
        || generationStatus === STATUS.FAILED
        || image.status === IMAGE_STATUS.DELIVERED ? (
        <>
          <ButtonStyled
            disabled={isLoading}
            variant='contained'
            onClick={handleRegenerate}>
            {builderPageId ? (
              <BuilderBlocks
                fieldName='regenerateButtonContent'
                child
                parentElementId={builderPageId}
                blocks={regenerateButtonContent}
              />
            ) : null}
          </ButtonStyled>
          <ButtonStyled
            disabled={isLoading}
            variant='outlined'
            onClick={handleStartNew}>
            Edit/Start New
          </ButtonStyled>
        </>
      ) : (
        <>
          <ButtonStyled
            disabled={isLoading}
            variant='contained'
            onClick={handleDelivery}
            startIcon={<MailIcon />}
            sx={(theme) => ({
              [theme.breakpoints.down('sm')]: {
                marginTop: '12px',
              },
            })}>
            Save Image
          </ButtonStyled>
          <ButtonStyled
            disabled={isLoading}
            variant='outlined'
            onClick={handleScrap}
            startIcon={<ScrapIcon />}>
            Scrap
          </ButtonStyled>
        </>
      )}
    </CTAButtonsContainer>
  );
};

MagicSvgActionButtons.propTypes = {
  currentView: PropTypes.string.isRequired,
  isPerformingAction: PropTypes.bool.isRequired,
  handleRegenerate: PropTypes.func.isRequired,
  handleStartNew: PropTypes.func.isRequired,
  handleDelivery: PropTypes.func.isRequired,
  handleScrap: PropTypes.func.isRequired,
};

export default MagicSvgActionButtons;
